import PanoramaImage from "../assets/products/panorama.png";
import CompanionImage from "../assets/products/companion.png";
import TDDImage from "../assets/products/tdd.png";
import NIS2Image from "../assets/products/nis2.png";
import ConfiguratorImage from "../assets/products/configurator.png";
import MCPImage from "../assets/products/mcp.png";
import PluginsImage from "../assets/products/plugins.png";

const products = [
    {
        id: "panorama",
        title: "Cyclopt Panorama",
        description: `Cyclopt Panorama is your cockpit for navigating software quality and team dynamics. Built on ISO/IEC 25010:2023, 
            it evaluates quality attributes like maintainability and security using sophisticated software metrics and ML-based benchmarks.
            From complexity to documentation scores, Panorama turns raw metrics into actionable insights. Set tailored notification plans, 
            get productivity and collaboration analytics, manage workloads effectively, and keep your projects on track with real-time alerts. 
            Whether you’re tracking performance, addressing risks, or optimizing resource allocation—Cyclopt Panorama offers the full picture.`,
        shortDescription: "Panoramic view app for Cyclopt. Actionable insights, alerts, and team productivity analytics in one place.",
        url: "https://panorama.cyclopt.com",
        learnMore: "https://cyclopt.com/panorama",
        image: PanoramaImage,
        field: "isPanoramaUser",
        color: "primary",
    },
    {
        id: "companion",
        title: "Cyclopt Companion",
        description: `Cyclopt Companion includes tools like Cyclopt Reporter and Cyclopt Profile, designed to support both individual developers and teams.
            Reporter provides automated code analysis on every commit, highlighting coding violations, vulnerabilities, and duplications. It also gives periodic 
            feedback on critical project dimensions like maintainability, security, and performance. Stay informed via web app or integrate with Discord, Slack, Mattermost, or Teams.
            Profile analyzes your development behavior to build a shareable developer profile, highlighting your strengths and growth. Use it for career advancement 
            or to better understand your own impact on code quality.`,
        shortDescription: "A companion app for Cyclopt, providing additional features and functionalities.",
        url: "https://companion.cyclopt.com",
        learnMore: "https://cyclopt.com/companion",
        image: CompanionImage,
        field: "isCompanionUser",
        color: "secondary",
    },
    {
        id: "mcp-server",
        title: "Cyclopt MCP Server",
        description: `The Cyclopt MCP Server connects AI coding assistants with Cyclopt's software intelligence, giving developers direct access
            to code quality, maintainability and security insights inside their workflow. Teams can query Cyclopt analysis results, review
            detected issues, understand key code metrics and receive actionable guidance while working with their AI assistant, without
            switching tools or interrupting development.`,
        shortDescription: "Connect AI coding assistants to Cyclopt analysis for in-workflow quality, security and maintainability insights.",
        url: "https://cyclopt.com/companion/mcp-server",
        image: MCPImage,
        field: "always",
        color: "#731D1D",
    },
    {
        id: "plugins",
        title: "Cyclopt Plugins",
        description: `Cyclopt plugins for Visual Studio, VS Code and JetBrains bring code quality and security insights directly into your
            IDE. Run analyzers, review issues in context, and get faster feedback while coding so teams can improve software quality,
            reduce technical debt and move faster with confidence.`,
        shortDescription: "IDE plugins for Visual Studio, Visual Studio Code and JetBrains with Cyclopt quality and security insights.",
        url: "https://cyclopt.com/companion/plugins",
        image: PluginsImage,
        field: "always",
        color: "#42AFE6",
    },
    {
        id: "tdd",
        title: "Technical Due Diligence",
        description: `Cyclopt’s Technical Due Diligence (TDD) service delivers a comprehensive quality report based on ISO/IEC 25010:2023. It provides a structured 
            evaluation of your software project’s maintainability and security, identifying technical risks and code issues that matter.
            Perfect for investment rounds, acquisitions, or internal audits, this service creates a bridge between development and business stakeholders. 
            Configure the TDD report to fit your goals and communicate results effectively to executives, investors, or potential partners.`,
        shortDescription: "Deep codebase evaluation service for investors and tech teams.",
        url: "https://tdd.cyclopt.com",
        learnMore: "https://www.cyclopt.com/services#tdd",
        image: TDDImage,
        field: "isTDDUser",
        color: "third",
    },
    {
        id: "nis2",
        title: "NIS2 Compliance Report",
        description: `The Cyclopt NIS2 Compliance Report helps organizations measure their readiness for the EU’s NIS2 cybersecurity directive. 
            Through an easy configuration process, you can select the security dimensions to assess, and receive a thorough report pinpointing areas of compliance and weakness.
            Backed by Cyclopt’s software quality analytics engine, this service translates regulatory requirements into technical actions. Use the report to 
            support management decisions, prepare for audits, and demonstrate compliance to stakeholders.`,
        shortDescription: "Comprehensive report to assess your organization’s compliance with the NIS2 Directive.",
        url: "https://nis2.cyclopt.com",
        learnMore: "https://www.cyclopt.com/services#nis2",
        image: NIS2Image,
        field: "isNIS2User",
        color: "third",
    },
    {
        id: "configurator",
        title: "Cyclopt Configurator",
        description: `The Cyclopt Configurator lets you fully customize how Cyclopt integrates into your workflow. Whether you’re managing a CI/CD pipeline, 
            automating quality gates, or building custom dashboards, the configurator puts you in control. Use the Cyclopt API to generate custom reports, 
            monitor specific quality metrics, tailor alerting, or embed analytics in your DevOps processes. It’s your toolbox for aligning quality control 
            with your development methodology, reducing risk, and improving output—without changing your preferred tools.`,
        shortDescription: "Tailor your quality workflow with Cyclopt’s versatile configuration tools and APIs.",
        url: "https://configurator.cyclopt.com/home",
        image: ConfiguratorImage,
        field: "always",
        color: "lightBlue",
    },
];

export default products;
